/**
 * UserEditButton - Button for editing a user.
 *
 * Displays an edit icon button that triggers the edit callback.
 */

import { Edit2 } from 'lucide-react';
import { Button } from '@lean-agility/design-system/react';
import type { UserResponse } from '@/lib/api';

export interface UserEditButtonProps {
  /**
   * User to edit.
   */
  user: UserResponse;
  /**
   * Async callback when button is clicked.
   */
  onEdit: (user: UserResponse) => Promise<void>;
}

export function UserEditButton({ user, onEdit }: UserEditButtonProps) {
  const handleClick = async () => {
    await onEdit(user);
  };

  return (
    <Button variant="ghost" size="sm" onClick={handleClick} aria-label={`Edit ${user.email}`}>
      <Edit2 className="size-4" />
    </Button>
  );
}
